import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Estado reactivo de sesión/actividad del usuario.
 *
 * Nota:
 * - Esto NO pertenece a `AppService` (HTTP/encripción).
 * - Se usa para coordinar timers de inactividad/sesión entre componentes (Main/Menu, etc.).
 */
@Injectable({ providedIn: 'root' })
export class SessionStateService {
  /** Indica cuándo la app debe iniciar el control de inactividad/sesión (post-login). */
  public readonly startIdleCount = new BehaviorSubject<boolean>(false);

  /** Indica finalización de sesión (true) o renovación (false). */
  public readonly sessionEnded = new BehaviorSubject<boolean>(false);

  /** Timestamp de la última actividad del usuario (Date.now()). */
  public readonly userActivity = new BehaviorSubject<number>(0);
}

